import { getOfficialSiteDomainByLang } from '@com/utils/domain'
import { getSessionStorage } from '@com/utils/storage'

export function privacyHref(): string {
  return `${getOfficialSiteDomainByLang()}/privacy`
}

export function getRefererFromStorage() {
  try {
    const item = getSessionStorage('referer')

    if (item) {
      const data = JSON.parse(item)

      return data.referer
    }
  } catch (e) {
    console.log(e)
  }
}

export function isUTM(query: Record<string, string>) {
  return query.campaignid && query.adgroupid && query.keyword
}
